export default __webpack_public_path__ + "static/media/phone2.cd14819e.png";